import { useEffect, useState } from "react";
import { FaTrash, FaCopy } from "react-icons/fa";

const EditRowModal = ({ show, onClose, error }) => {
  const getToday = () => {
    return new Date().toISOString().split("T")[0];
  };

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content rounded-3 shadow-sm border-0">
          <div
            className="modal-header py-2 px-3"
            style={{ borderBottom: "0px" }}
          >
            <h5
              className="modal-title fw-semibold"
              style={{ fontSize: "18px" }}
            >
              Edit Row
            </h5>
            <button
              type="button"
              style={{ fontSize: "14px" }}
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body px-4 pb-3">
            <div className="d-flex justify-content-between align-items-center mb-3"></div>

            {/* Amount Section */}
            <div className="row g-3" style={{ background: "#F6F7FC" }}>
              <p className="m-0 fw-semibold" style={{ fontSize: "16px" }}>
                Details
                <span
                  className="badge bg-light ms-1"
                  style={{ color: "#616A87" }}
                ></span>
              </p>
              <div className="col-md-4">
                <label
                  htmlFor=""
                  style={{ fontWeight: "500" }}
                  className="px-1"
                >
                  Invoice Number
                </label>
                <input type="text" className="form-control mb-3 fw-medium" />
              </div>
              <div className="col-md-4">
                <label
                  htmlFor=""
                  style={{ fontWeight: "400" }}
                  className="px-1"
                >
                  Posting Date
                </label>
                <input
                  type="date"
                  value={getToday()}
                  style={{ fontWeight: "400", fontSize: "0.7rem" }}
                  className="form-control mb-3 fw-medium "
                />
              </div>{" "}
              <div className="col-md-4">
                <label
                  htmlFor=""
                  style={{ fontWeight: "400" }}
                  className="px-1"
                >
                  Due Date
                </label>
                <input
                  type="date"
                  value={getToday()}
                  style={{ fontWeight: "400", fontSize: "0.7rem" }}
                  className="form-control mb-3 fw-medium "
                />
              </div>
            </div>
            <div className="row g-3 mt-2 p" style={{ background: "#FDF8ED" }}>
              <div className="col-md-4">
                <label
                  htmlFor=""
                  style={{ fontWeight: "500" }}
                  className="px-1"
                >
                  Item Name
                </label>
                <input type="text" className="form-control mb-3 fw-medium" />
              </div>
              <div className="col-md-4">
                <label
                  htmlFor=""
                  style={{ fontWeight: "400" }}
                  className="px-1"
                >
                  Outstanding Amount
                </label>
                <input type="text" className="form-control mb-3 fw-medium" />
              </div>{" "}
              <div className="col-md-4">
                <label
                  htmlFor=""
                  style={{ fontWeight: "400" }}
                  className="px-1"
                >
                  Quantity
                </label>
                <input type="text" className="form-control mb-3 fw-medium" />
              </div>
            </div>
            <div className="row g-3 mt-2">
              <div className="col-6">
                <div className="d-flex gap-2">
                  {/* DELETE BUTTON */}
                  <button
                    style={{ backgroundColor: "#FF5969", color: "white" }}
                    className="hoverflow d-flex align-items-center gap-2 px-3 py-2"
                  >
                    {" "}
                    <FaTrash
                      color="FF5969"
                      size={16}
                      style={{ cursor: "pointer" }}
                    />
                    Delete
                  </button>

                  {/* DUPLICATE BUTTON */}
                  <button
                    style={{ backgroundColor: "#A2B1E1", color: "white" }}
                    className="hoverflow d-flex align-items-center gap-2 px-3 py-2"
                  >
                    <FaCopy
                      size={16}
                      color="white"
                      style={{ cursor: "pointer" }}
                    />
                    Duplicate
                  </button>
                </div>
              </div>
              <div className="col-6">
                <div className="d-flex justify-content-end align-items-end">
                  {/* DELETE BUTTON */}

                  {/* DUPLICATE BUTTON */}
                  <button
                    style={{ backgroundColor: "#855C6E", color: "white" }}
                    className="hoverflow d-flex align-items-center gap-2 px-3 py-2"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditRowModal;
